import { ModuleWithProviders, NgModule } from '@angular/core';
import { LibConfiguration } from './lib-configuration';
import { LIB_CONFIG } from './lib-configuration-token';

@NgModule()
export class ComponentsModule {
  static forRoot(
    libConfoguration: LibConfiguration
  ): ModuleWithProviders<ComponentsModule> {
    return {
      ngModule: ComponentsModule,
      providers: [
        {
          provide: LIB_CONFIG,
          useValue: libConfoguration,
        },
      ],
    };
  }
}
